module.exports = __webpack_public_path__ + "static/img/2.944b4f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/zh/2.png
// module id = xLGD
// module chunks = 0